import React from "react";
import { aiPoints, images } from "../data/content";
export function AiAssistant() {
  return <section className="bg-white px-4 py-14" aria-labelledby="ai-title" data-id="element-1" data-mp="z1wzd38jay6y">
      <div className="mx-auto grid max-w-5xl items-center gap-10 md:grid-cols-[1.3fr_1fr]" data-id="element-2" data-mp="yzk8u1opnfia">
        <div data-id="element-3" data-mp="1cuuwau0mkycm">
          <h2 id="ai-title" className="font-heading text-2xl font-bold uppercase leading-tight" data-id="element-4" data-mp="1821x0lnxei7x">
            Your smart assistant, <span className="text-brand" data-id="element-5" data-mp="1mqg5bc442yvv">always by your side</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink-muted" data-id="element-6" data-mp="1hrv3575au54s">
            An AI woodworking assistant that knows every plan in the collection is included, ready to answer your questions in seconds.
          </p>
          <ul className="mt-6 space-y-4" data-id="element-7" data-mp="1qs1d4j1sgmz7">
            {aiPoints.map(p => <li key={p.title} data-id="element-8" data-mp="1qqqd8ubgrzdd">
                <span className="inline-block rounded bg-brand px-2 py-0.5 font-heading text-xs font-bold uppercase text-white" data-id="element-9" data-mp="1d3cozrpr7y4">{p.title}</span>
                <p className="mt-1.5 text-sm text-ink-muted" data-id="element-10" data-mp="3slqz7j1ox179">{p.text}</p>
              </li>)}
          </ul>
        </div>
        <img src={images.robot} alt="Robot assistant wearing an orange hard hat" className="mx-auto w-64 md:w-full" data-id="element-11" data-mp="ufo1ohre37yu" />
      </div>
    </section>;
}